/* Generated USDT deposit helpers unit. */
// Public branding may be cached; private finance values never enter the guest cache.
const privateKeys = new Set([
  'usdt_headquarters_wallet_address', 'usdt_company_wallet_address', 'usdt_wallet_address',
  'headquarters_usdt_wallet_address', 'crypto_wallet_address', 'wallet_address', 'walletAddress',
  'deposit_notes', 'withdrawal_notes', 'anonymous_deposit_notes', 'anonymous_withdrawal_notes',
]);
export const publicWalletSettings = value => {
  if (!value || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(publicWalletSettings);
  return Object.fromEntries(Object.entries(value).filter(([key]) => !privateKeys.has(key))
    .map(([key, item]) => [key, publicWalletSettings(item)]));
};
